/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedContactDealerWrapper_item$ref = any;
export type PdpRespHeroCarouselRequestMoreImages_item$ref = any;
export type PdpRespHeroCarouselRequestMoreImages_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": SharedContactDealerWrapper_item$ref;
    readonly " $refType": PdpRespHeroCarouselRequestMoreImages_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarouselRequestMoreImages_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item",
      "args": null
    }
  ]
};
(node as any).hash = '092c74d315099a40ad4b44ee46353114';
export default node;
